import { Headline5 } from '@nexus/lib-react/dist/core/Typography/Heading';
import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';
import DocumentLock from '../assets/document-lock.svg';

export const InfoCardContainer = styled.div`
  display: none;
  ${mq.desktop} {
    display: flex;
    flex-direction: column;
    background: #fffbef;
    padding: 48px 42px;
    flex: 1 1 auto;
    border-radius: ${({ theme }) => theme.radii.primary};
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Headline5)`
  flex: 1 1 auto;
  margin: 16px 0px;
  ${mq.desktop} {
    flex: 0 1 auto;
    width: auto;
  }
`;

export const DocumentLockIcon = styled(DocumentLock)`
  width: 46px !important;
  height: 48px !important;
`;

export const ContentContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;

  ${mq.desktop} {
    display: block;
    margin-bottom: 0;
  }
`;

export const Li = styled.li`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors['text-brand-primary']};
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.colors['text-brand-primary']};
  font-weight: ${({ theme }) => theme.fontWeights[400]};
  text-decoration: underline;
`;

export default {
  InfoCardContainer,
  HeaderContainer,
  Title,
  DocumentLockIcon,
  ContentContainer,
  Li,
  Link,
};
